import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    // Check if this is a CardNet-related error
    const isCardNetError = /cardnet|seglan|servicios|PWCheckout|etp-seglan|cross-origin|Script error|browser flakiness|invokeGuardedCallback/i.test(
      error.message || ''
    );

    // If it's a CardNet error, don't show the error boundary
    if (isCardNetError) {
      return { hasError: false };
    }

    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Check if this is a CardNet-related error
    const isCardNetError = /cardnet|seglan|servicios|PWCheckout|etp-seglan|cross-origin|Script error|browser flakiness|invokeGuardedCallback/i.test(
      error.message || ''
    );

    // If it's a CardNet error, don't log it
    if (isCardNetError) {
      return;
    }

    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div className="min-h-screen bg-white flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-900 mb-4">
              Algo salió mal
            </h1>
            <p className="text-gray-600 mb-4">
              Ha ocurrido un error inesperado. Por favor recarga la página.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="bg-black text-white px-6 py-2 rounded-lg hover:bg-gray-800"
            >
              Recargar página
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
